import React from 'react';
import {Routes, Route} from 'react-router';

import {ResetPasswordForm} from './Form';
import {ResetPasswordSuccess} from './Success';

const ResetPassword = () => (
  <>
    <Routes>
      <Route path="success" element={<ResetPasswordSuccess />} />
      <Route index element={<ResetPasswordForm />} />
    </Routes>
  </>
);

export {ResetPassword};
